import React from 'react';
import { MarketingShell, CONTACT_EMAIL, IMG } from './LandingPage';

const POSTS = [
  {
    title: 'Reliable and Efficient',
    text: 'NAC Easy Solution has significantly improved our sales tracking and inventory management, saving us time and reducing errors.',
    img: IMG.quote1,
  },
  {
    title: 'User-Friendly Interface',
    text: 'The system is easy to navigate, allowing our staff to adapt quickly without extensive training.',
    img: IMG.quote2,
  },
  {
    title: 'Excellent Support',
    text: 'Their customer service is responsive and helpful, ensuring our business runs smoothly at all times.',
    img: IMG.quote3,
  },
];

const BlogPage: React.FC = () => (
  <MarketingShell
    title="Blog & Resources - NAC Easy Solution"
    description="Hear from business owners in Bhutan who have transformed their shops with NAC Easy Solution."
  >
    <section className="sk-page-hero" style={{ backgroundImage: `url(${IMG.sales})` }}>
      <div>
        <h1>What Our Clients Say</h1>
        <p>Hear from business owners in Bhutan who have transformed their shops with NAC Easy Solution.</p>
      </div>
    </section>

    <section className="sk-section sk-quotes">
      <div className="sk-grid-3">
        {POSTS.map((post) => (
          <article key={post.title} className="sk-card">
            <div className="sk-card-img" style={{ backgroundImage: `url(${post.img})` }} />
            <h3>{post.title}</h3>
            <p>{post.text}</p>
          </article>
        ))}
      </div>
      <div style={{ textAlign: 'center', marginTop: 28 }}>
        <a className="sk-btn" href={`mailto:${CONTACT_EMAIL}`}>Contact Us</a>
      </div>
    </section>
  </MarketingShell>
);

export default BlogPage;
